import { ApiClient } from "@ucl/library";
import variables from "@config/variables";

// Create a single instance of ApiClient to be used across the application
export const apiClient = new ApiClient(variables.apiBaseUrl); 